import { useHistory } from "react-router-dom";
import { Icon } from "@circle-react/components/shared/Icon";

interface HeaderBackButtonProps {
  onClick?: () => void;
}

const HeaderBackButton = ({ onClick }: HeaderBackButtonProps) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="hover:bg-tertiary w-8 rounded-lg p-1"
    >
      <Icon type="16-arrow-left" useWithFillCurrentColor size={16} />
    </button>
  );
};

export default HeaderBackButton;
